<template>

  <AspectRatio>

    <transition name="fade" mode="out-in">
      <LoadingScreen v-if="isLoading"></LoadingScreen>
    </transition>

    <template v-if="!isLoading">

      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>

    </template>
    
    <Globe 
      :globeState="globeState"
      :enabled="showGlobe"
      :selectedCaseId="selectedCaseId"
      :isCaseOpen="isCaseOpen"
      :selectedLayer="selectedDataLayer"
      :challenge="selectedChallenge"
      :cases="cases"
      :viewCaseLabel="viewCaseLabel"/>

    <Background :backgroundModifier="backgroundModifier" :data-test="backgroundModifier"></Background>


  </AspectRatio>

</template>

<script>
import './scss/main.scss';
import store from './dataStore';
import AspectRatio from './components/AspectRatio';
import LoadingScreen from './components/LoadingScreen';
import Globe from '@/components/Globe';
import Background from '@/components/Background';

export default {
  name: 'App',
  components: {
    AspectRatio: AspectRatio,
    LoadingScreen: LoadingScreen,
    Globe: Globe,
    Background: Background
  },
  data() {
    return {
      isLoading: false,
      selectedChallenge: null,
      selectedCase: null,
      selectedDataLayer: null,
      globeState: 'normal',
      cases: [],
      // NOTE(Mølby): Text strings
      viewCaseLabel: '',
      backgroundIsTransitioning: false
    }
  },
  computed:
  {
    backgroundModifier()
    {
      // NOTE(Mølby): Use route to decide which background state to show
      var currentBackgroundId = 'home';

      if (!this.$route.name)
      {
        currentBackgroundId = 'none';
      }

      var isDenmark = (this.$route.path.indexOf('denmark') != -1);
      var isEurope = (this.$route.path.indexOf('europe') != -1);
      var caseIsOpen = this.isCaseOpen;

      if (isDenmark)
      {
        currentBackgroundId = 'denmark';
      }
      else if (isEurope)
      {
        currentBackgroundId = 'europe';
      }

      if (isDenmark && caseIsOpen)
      {
        currentBackgroundId = 'denmark-case';
      }
      else if (isEurope && caseIsOpen)
      {
        currentBackgroundId = 'europe-case';
      }

      return currentBackgroundId;
    },
    showGlobe()
    {
      
       
      return (this.$route.path.indexOf('denmark') === -1) && (this.$route.path.indexOf('europe') === -1) && (!this.backgroundIsTransitioning);
    },
    isCaseOpen()
    {
      return (this.$route.params.caseId != null);
    },
    selectedCaseId()
    {
      return parseInt(this.$route.params.caseId);
    }
  },
  created()
  {
    this.unsubscribeFromStore = store.subscribe((storeState)=>{
        this.isLoading = storeState.isLoading;
        this.selectedChallenge = storeState.selectedChallenge;
        this.selectedCase = storeState.selectedCase;
        this.selectedDataLayer = storeState.selectedDataLayer;
        this.cases = storeState.cases;
        this.globeState = storeState.globeState;
        this.viewCaseLabel = storeState.siteInfo.challengesPageViewCaseLinkText;
        this.backgroundIsTransitioning = storeState.backgroundIsTransitioning;
    });

		store.loadManifest();
  },
  unmounted()
  {
    this.unsubscribeFromStore();
  }
}
</script>